import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {
  #storage: Storage;
  #platformId: object;
  constructor() {
    // eslint-disable-next-line no-restricted-syntax -- test
    this.#platformId = inject(PLATFORM_ID);

    this.#storage = isPlatformBrowser(this.#platformId)
      ? sessionStorage
      : ({
          getItem: () => null, // Return null on the server
          setItem: () => {}, // Do nothing on the server
          removeItem: () => {}, // Do nothing on the server
          clear: () => {} // Do nothing on the server
        } as unknown as Storage);
  }

  setItem(key: string, value: any): void {
    this.#storage.setItem(key, JSON.stringify(value));
  }
  getItem<T = any>(key: string): T | null {
    const storedValue = this.#storage.getItem(key);
    return storedValue ? (JSON.parse(storedValue) as T) : null;
  }
  removeItem(key: string): void {
    this.#storage.removeItem(key);
  }
  clear() {
    this.#storage.clear();
  }
}
